import { styled } from '@mui/material/styles';
import { CfDataGridDisplayMode } from '../../../../../../../../cf-ui/DataGrid/CfDataGridProps';

interface DisplayModeProps {
  size: 'small' | 'medium';
  displayMode: CfDataGridDisplayMode;
}

export const StyledImageContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'displayMode' && prop !== 'size',
})<DisplayModeProps>(({ theme, displayMode, size }) => ({
  position: 'relative',
  display: 'flex',

  [theme.breakpoints.up('xs')]: {
    alignItems: 'flex-start',
  },
  [theme.breakpoints.up('xl')]: {
    alignItems: 'center',
  },

  ...(displayMode === 'table'
    ? {
        width: 68,
        minWidth: 68,
        height: 68,
      }
    : {
        ...(size === 'small'
          ? {
              width: 155,
              minWidth: 155,
              height: 155,
            }
          : {
              width: 200,
              minWidth: 200,
              height: 200,
            }),
      }),
}));

export const StyledImage = styled('img', {
  shouldForwardProp: (prop) => prop !== 'displayMode' && prop !== 'size',
})<DisplayModeProps>({
  cursor: 'pointer',
  width: '100%',
  height: '100%',
  objectFit: 'contain',
});
